import { Button, InputWraper, useForm } from 'modules';
import React from 'react';
import { useRejectRequestWithdrawMutation } from 'services';
import { InputText, InputNumber, InputTextArea } from 'components';

import { PopupWraper } from 'components';
import { WithdrawRequestEntity } from 'services/openapi';
import { toast } from 'react-hot-toast';
import { RejectRequestWithdrawType } from '../../../../../services/requestWithdraw/mutation/useRejectRequestWithdrawMutation';

interface RejectRequestWithdrawProps {
  onClose: () => void;
  forceUpdateTable: () => void;
  data: WithdrawRequestEntity | null;
}

const RejectRequestWithdraw = ({
  onClose,
  forceUpdateTable,
  data,
}: RejectRequestWithdrawProps) => {
  const { mutateAsync, mutate, isLoading } = useRejectRequestWithdrawMutation();
  const { handleSubmit, getInputProps, resetForm, setValues } = useForm({
    structure: [
      {
        name: 'amount',
        label: 'Số tiền',
        defaultValue: data?.amount,
        isDisabled: true,
      },
      {
        name: 'bankAccountName',
        label: 'Tài khoản',
        defaultValue: data?.bankAccount?.accountName,
        isDisabled: true,
      },
      {
        name: 'bankName',
        label: 'Ngân hàng',
        defaultValue:
          data?.bankAccount?.bank?.shortName +
          ' - ' +
          data?.bankAccount?.bank?.name,
        isDisabled: true,
      },
      {
        name: 'bankAccount',
        label: 'Số tài khoản',
        defaultValue: data?.bankAccount?.accountNumber,
        isDisabled: true,
      },
      {
        name: 'rejectReason',
        label: 'Lý do từ chối',
      },
    ],
    onSubmit: async (values) => {
      const normalizedValues = { rejectReason: values.rejectReason };
      const request: RejectRequestWithdrawType = {
        id: data?.id ?? '',
        variables: normalizedValues,
      };
      console.log('request', request);
      try {
        await mutateAsync(request);
        resetForm();
        forceUpdateTable();
        onClose();
        toast.success('Từ chối yêu cầu rút tiền thành công');
      } catch (error) {
        console.log('error', error);
      }
    },
  });

  return (
    <div className='wrap-pop-up-create-user'>
      <PopupWraper
        center
        title='Từ chối yêu cầu rút tiền'
        onClose={() => onClose()}
      >
        <div className='container-fluid'>
          <div className='wrap-form-accept-request'>
            <InputWraper
              className='col-lg-12'
              inputProps={getInputProps('amount')}
              component={InputNumber}
            />
            <InputWraper
              className='col-lg-12'
              inputProps={getInputProps('bankAccountName')}
              component={InputText}
            />
            <InputWraper
              className='col-lg-12'
              inputProps={getInputProps('bankName')}
              component={InputText}
            />
            <InputWraper
              className='col-lg-12'
              inputProps={getInputProps('bankAccount')}
              component={InputText}
            />
            <InputWraper
              className='col-lg-12'
              inputProps={getInputProps('rejectReason')}
              component={InputTextArea}
            />
          </div>
        </div>
        <div className='wrap-button-create-user'>
          <Button
            label='Từ chối'
            type='submit'
            onClick={handleSubmit}
            buttonType='danger'
            isLoading={isLoading}
          />
          <Button label='Trở về' buttonType='grey' onClick={() => onClose()} />
        </div>
      </PopupWraper>
    </div>
  );
};

export default RejectRequestWithdraw;
